<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
    {{message}}
</div>
<div mat-dialog-actions class="mat-dialog-actions">
    <button type="button" mat-button mat-dialog-close>No</button>
    <button type="button" mat-button [mat-dialog-close]="true" cdkFocusInitial mat-raised-button color="primary">Yes</button>
</div>
